import script from "./VehicleServiceTypesList.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleServiceTypesList.vue?vue&type=script&setup=true&lang=js"

import "./VehicleServiceTypesList.vue?vue&type=style&index=0&id=ad0bf836&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0bf836"]])

export default __exports__